import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import { deleteStatus, gettokendata, updateuserProfile } from '../../actions/users';
import { toastAlert } from "../../lib/toastAlert";
import Web3 from 'web3';


const UsersEdit = () => {
	const location = useLocation();
	const navigate = useNavigate()
	const [passchange, setPasschange] = useState(false)
	const [formValue, setFormValue] = useState({});
	const [validateError, setValidateError] = useState({});
	const [field, setField] = useState()

	useEffect(() => {
		setFormValue(location.state)
		setField(location.state.curraddress)
	}, [])

	const onChange = (e, index) => {
		e.preventDefault();
		const { id, value } = e.target;
		if (id == "curraddress") {
			var address = formValue.curraddress
			address[index] = value
			let formdata = { ...formValue, ...address }
			setFormValue(formdata)
		} else {
			let formData = { ...formValue, ...{ [id]: value } }
			setFormValue(formData)

		}
		if (id == "normalpassword") {
			setPasschange(true);
		}
	}
	const deladd = async (index) => {

		let reqData = {
			id: formValue.id,
			index: index,
			address: formValue.curraddress[index],
			action: "delete"
		}
		let data = await updateuserProfile(reqData);
		if (data && data.status === true) {
			setValidateError("");
			setFormValue(data.users)
			toastAlert("success", data.msg);
			setPasschange(false)

		} else {

			toastAlert("error", data.msg);
			setValidateError('Error Occured');
		}

	}

	const handleFormSubmit = async (e) => {

		e.preventDefault();
		
		var err = await validation(formValue);
		if (Object.keys(err).length && !(err.curraddress == false)) {
			let reqData = {
				id: formValue.id,
				passchange: passchange,
				curraddress: formValue.curraddress,
				signgame: formValue.name,
				signemail: formValue.signemail,
				normalpassword: formValue.normalpassword,
				action: "update"
			}
			let data = await updateuserProfile(reqData);
			if (data && data.status === true) {
				setValidateError("");
				toastAlert("success", data.msg);
				setPasschange(false)
				setTimeout(() => {
					navigate('/UserList')
				}, 1000);

			} else {

				toastAlert("error", data.msg);
				setValidateError('Error Occured');
			}
		}
		else {
			toastAlert("error", "Error Occured")
		}
	}

	const addfield = () => {
		var data = formValue;
		data.curraddress.push("")
		setFormValue({ ...formValue, ...data })

	}

	const validation = async (data) => {
		var emailcheck = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		var validation = {};

		var waladdstatus
			= await Promise.all(data.curraddress.map((add) => {
				if (!Web3.utils.isAddress(add)) {
					return false
				}
				else {
					return true

				}
			}))
		validation.curraddress = waladdstatus;
		if (!emailcheck.test(data.signemail)) {
			validation.signemail = "email Format is not correct"
		}
		if (!data.signemail) {
			validation.signemail = "email required"
		}
		setValidateError(validation)
		return validation;

	}

	return (
		<>
			<Container fluid className="common_bg position-relative">
				<div className="liner"></div>
				<Row>
					<Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
						<Sidebar />
					</Col>
					<Col xl={10} lg={12}>
						<Header title={'User Profile'} />
						<div className='common_page_scroller mt-5 pe-2'>
							<div>
								<button className='btn addcate' onClick={() => navigate(-1)}>Back</button>
							</div>
							<form noValidate autoComplete="off">
								<div color="primary" className="addcategorys">
									<h4>User Profile</h4>
								</div>

								<div className="categorylisdt">
									<div className='row'>
									
										{formValue && formValue?.curraddress?.map((item, index) => (
											<div className='col-xl-5 mt-4' key={index}>
												<label htmlFor={`curraddress`}>Current Address</label>
												<input
													type="text"
													className='form-control'
													id={`curraddress`}
													value={item || ""}
													onChange={(e) => onChange(e, index)}
													fullWidth
												/>
												<button type='button' color="primary" className='btn addcate px-3 py-2 mt-2 mb-0' onClick={(e) => deladd(index)} >Delete Address</button>
												{validateError.curraddress && (
													<span>
														{validateError.curraddress[index] === false && <>Wallet Address is not correct</>}
													</span>
												)}
											</div>
										))}

										<div className='col-xl-5 mt-4'>
											<label htmlFor="name">Name</label>
											<input
												type="text"
												className='form-control'
												id="name"
												onChange={(e) => onChange(e)}
												value={formValue?.name || ""}
												fullWidth
											/>
											{validateError.name && <span>{validateError.name}</span>}
										</div>

										<div className='col-xl-5 mt-4'>
											<label htmlFor="signemail">Email address</label>
											<input
												type="email"
												className='form-control'
												id="signemail"
												onChange={(e) => onChange(e)}
												value={formValue?.signemail || ""}
												fullWidth
											/>
											{validateError.signemail && <span>{validateError.signemail}</span>}
										</div>

										<div className='col-xl-5 mt-4'>
											<label htmlFor="normalpassword">Password</label>
											<input
												type="text"
												className='form-control'
												id="normalpassword"
												onChange={(e) => onChange(e)}
												value={formValue?.normalpassword || ""}
												fullWidth
											/>
										</div>
									</div>
								</div>

								<div className='d-flex gap-3'>
									<button type="button" color="primary" className='btn addcate px-2 py-2 mt-4' onClick={(e) => handleFormSubmit(e)} >Update Profile</button>
									<button type="button" color="primary" className='btn addcate px-2 py-2 mt-4' onClick={() => addfield()}>Add Wallet Address</button>
								</div>
							</form>

						</div>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export default UsersEdit